import { TriangleAlert } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import {
  useAudiencePreview,
  type NotificationType,
} from 'hooks/useNotification';
import { reachabilityWarnings } from './reachability';

/**
 * Warns when named recipients have no address for the email or text channels
 * picked.
 */
export function ReachabilityWarning({
  userIds,
  teamIds,
  roleScopeKeys,
  roleIds,
  notificationTypes,
}: {
  userIds?: string[];
  teamIds?: string[];
  roleScopeKeys?: string[];
  roleIds?: string[];
  notificationTypes: string[];
}) {
  const checked = notificationTypes.filter(
    (type) => type === 'email' || type === 'sms'
  ) as NotificationType[];
  const preview = useAudiencePreview({
    userIds,
    teamIds,
    roleScopeKeys,
    roleIds,
    notificationTypes: checked,
    enabled: checked.length > 0,
  });
  const warnings = checked.length > 0 ? reachabilityWarnings(preview.data) : [];
  if (warnings.length === 0) return null;
  return (
    <Alert>
      <TriangleAlert />
      <AlertDescription>
        {warnings.map((warning) => (
          <p key={warning} className="tw:m-0">
            {warning}
          </p>
        ))}
      </AlertDescription>
    </Alert>
  );
}
